module.exports = __webpack_public_path__ + "img/upload-pri.45c58bf2.svg";